export default __webpack_public_path__ + "static/Rudiger-e1585576181743-ee86a8328d0237b64b6f5df6ca6bd28d.jpg";